import React from 'react'

const PaymentDetails = () => {
  return (
    <div className='p-2 border w-full border-gray-200'>
     <h1 className='font-bold text-lg py-2'>Payment Details</h1>
     <div className='flex  justify-between py-1.5 border border-transparent '>
         <h1 className='text-gray-web text-sm'>MRP Total</h1>
         <h1 className='text-jet text-sm font-semibold '>₹1,064.00</h1>
     </div>

     <div className='flex justify-between py-1.5 border border-transparent '>
         <h1 className='text-gray-web text-sm '>Product Discount</h1>
         <h1 className='text-jet text-sm font-semibold '> -₹344.00</h1>
     </div>
     <div className='flex justify-between py-1.5 border border-transparent '>
         <h1 className='text-gray-web text-sm '>Coupon Discount</h1>
         <h1 className='text-jet text-sm font-semibold '> -₹344.00</h1>
     </div>
     <div className='flex justify-between py-1.5 border border-transparent '>
         <h1 className='text-gray-web text-sm '>Convinience Fee</h1>
         <h1 className=' font-semibold text-positive px-2'> Free </h1>
     </div>

     <div className='flex justify-between py-2 mt-2 border border-transparent border-t-gray-800 '>
         <h1 className='text-jet  text-md font-bold '>Total Amout</h1>
         <h1 className='text-jet text-md font-semibold '> ₹17,064.00</h1>
     </div>
     
     <div className='w-full  my-3 '>
     <button className='   border w-full  text-md font-semibold bg-rose-500 hover:bg-rose-500/90 border-rose-400 transition-colors duration-100  text-white px-8 py-1  rounded-sm '> Place Order </button>

     </div>

    </div>
  )
}

export default PaymentDetails